import { Box, Typography } from "@mui/material";
import React from "react";

/**
 * Common EditableDetailRow component for grid-aligned label-input fields.
 */
const EditableDetailRow = ({
  label,
  required = false,
  labelWidth = "130px",
  children,
  sx = {},
}) => {
  const formattedLabelWidth =
    typeof labelWidth === "number" ? `${labelWidth}px` : labelWidth;

  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: {
          xs: "1fr",
          sm: `${formattedLabelWidth} minmax(0, 1fr)`,
        },
        alignItems: "center",
        columnGap: 1,
        rowGap: 0.5,
        minWidth: 0,
        ...sx,
      }}
    >
      <Typography
        component="label"
        sx={{
          fontSize: "0.78rem",
          fontWeight: 500,
          color: "#334155",
          // whiteSpace: "nowrap", Need to Confirm
        }}
      >
        {label}
        {required && (
          <Box
            component="span"
            sx={{
              color: "#d32f2f",
              ml: 0.25,
            }}
          >
            *
          </Box>
        )}
      </Typography>

      <Box
        sx={{
          minWidth: 0,
          "& .MuiInputBase-root": {
            fontSize: "0.8rem",
          },
          "& .MuiInputBase-input": {
            py: 0.7,
          },
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default React.memo(EditableDetailRow);
